import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[trimInput]'
})
export class TrimInputDirective {

  constructor(private el: ElementRef<HTMLInputElement>) {}

  private clean(value: string): string {
    if (!value) return value;
    return value.trim();
  }

  @HostListener('blur')
  onBlur() {
    const cleaned = this.clean(this.el.nativeElement.value);
    this.el.nativeElement.value = cleaned;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const text = event.clipboardData?.getData('text') ?? '';
    const cleaned = this.clean(text);
    document.execCommand('insertText', false, cleaned);
  }
}
